import React, { useState, useEffect } from "react";
import { calculateDeliveryDate, calculateDeliveryDateFromNow } from "../../../utils/functions";
import { ThemeProvider } from "styled-components";
import theme from "./../../themes/default";
import { isMobile } from "react-device-detect";
import SummCounter from "./../../molecules/SummCounter";
import SidebarMeals from "./../../molecules/SidebarMeals";
import CTA from "./../../molecules/CTA";
import { Wrap, Inner, Overlay } from "./styles";
import { Heading } from "./Heading";
import { getWrapClass, excludedMealsInBasket } from "./utils";

function Sidebar(props) {
  const {
    isLoaded,
    hadleClearAll,
    handleDeleteItem,
    selectedMeals,
    toCart,
    handleCTAClick,
    limitations,
    selectedExclusions,
    selectedDiet,
    dietType,
    configPageUrl,
    dietitian,
    handleDietitianChange,
    compactHeader,
    mode,
    charge,
    programType,
    mealSettings,
    main_title,
    selectedProgram,
  } = props;
  const wrapRef = React.createRef();
  const innerRef = React.createRef();
  const [sidebarStatus, setSidebarStatus] = useState(false);
  const [sticky] = useState(false);

  useEffect(() => {
    if (isMobile) {
      handleHeight();
    }
  });

  const handleMealChange = (item) => {
    props.handleMealChange(item);
  };

  const handleHeight = () => {
    let wrapElement = wrapRef.current,
      innerElement = innerRef.current;

    wrapElement.style.height = innerElement.offsetHeight + "px";
  };

  const toggleSidebarMobile = () => {
    setSidebarStatus(!sidebarStatus);
  };

  const closeSidebarMobile = () => {
    setSidebarStatus(false);
  };

  const handlePrevClick = (e) => {
    e.preventDefault();
    props.handlePrevClick();
  };

  const handleClickEditQuantity = () => {
    props.handleClickEditQuantity();
  };

  const calculatedDate = calculateDeliveryDateFromNow();
  const deliveryDate = typeof charge.scheduledAt !== "undefined" ? calculateDeliveryDate(charge.scheduledAt, "short") : "";
  const isExcludedMeals = excludedMealsInBasket(selectedExclusions, selectedMeals);
  const wrapClass = getWrapClass(mode, compactHeader);

  return (
    <ThemeProvider theme={theme}>
      <Wrap ref={wrapRef} className={wrapClass}>
        {sidebarStatus === true && <Overlay onClick={closeSidebarMobile} />}
        <Inner className={sticky ? "sticky inner-sidebar" : "inner-sidebar"} ref={innerRef}>
          <Heading
            mode={mode}
            configPageUrl={configPageUrl}
            calculatedDate={calculatedDate}
            deliveryDate={deliveryDate}
            handlePrevClick={handlePrevClick}
            sidebarStatus={sidebarStatus}
            selectedMeals={selectedMeals}
            isExcludedMeals={isExcludedMeals}
            toggleSidebarMobile={toggleSidebarMobile}
          />
          {compactHeader === false && (
            <SummCounter
              selectedMeals={selectedMeals}
              limitations={limitations}
              selectedProgram={selectedProgram}
              dietType={dietType}
              main_title={main_title}
            />
          )}
          <SidebarMeals
            selectedMeals={selectedMeals}
            selectedExclusions={selectedExclusions}
            handleMealChange={handleMealChange}
            hadleClearAll={hadleClearAll}
            handleDeleteItem={handleDeleteItem}
            sidebarStatus={sidebarStatus}
            limitations={limitations}
            selectedDiet={selectedDiet}
            selectedProgram={selectedProgram}
            compactHeader={compactHeader}
            charge={charge}
            dietType={dietType}
            main_title={main_title}
          />
          <CTA
            isLoaded={isLoaded}
            toCart={toCart}
            selectedMeals={selectedMeals}
            handleCTAClick={handleCTAClick}
            limitations={limitations}
            selectedDiet={selectedDiet}
            selectedProgram={selectedProgram}
            configPageUrl={configPageUrl}
            dietitian={dietitian}
            handleDietitianChange={handleDietitianChange}
            mode={mode}
            programType={programType}
            mealSettings={mealSettings}
            handleClickEditQuantity={handleClickEditQuantity}
            charge={charge}
            dietType={dietType}
          />
        </Inner>
      </Wrap>
    </ThemeProvider>
  );
}

export default Sidebar;
